

<div class="container-fluid">
                <div class="DashboardContainer">
                      
                                <div class="container-fluid">
                                                <div class="row">
                                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 bhoechie-tab-container">
                                                    <div class="col-lg-1 col-md-1 col-sm-4 col-xs-12 bhoechie-tab-menu">
                                                      <div class="list-group">
                                                        <a  [routerLink]="['/PolicyDashboard/Policy']" class="list-group-item  text-center" routerLinkActive="active">
                                                          <h4 class="glyphicon glyphicon-dashboard"></h4><br/> Dashboard
                                                        </a>
                                                        <a [routerLink]="['/PolicyDashboard/Proposals']" class="list-group-item  text-center" routerLinkActive="active">
                                                          <h4 class="glyphicon glyphicon-tasks"></h4><br/>My Proposals
                                                        </a>
                                                        <a  [routerLink]="['/PolicyDashboard/AddNewPolicy']" class="list-group-item  text-center" routerLinkActive="active">
                                                          <h4 class="glyphicon glyphicon-plus"></h4><br/>Add New Policy
                                                        </a>
                                                        <a [routerLink]="['/PolicyDashboard/Profile']" class="list-group-item  text-center" routerLinkActive="active">
                                                          <h4 class="glyphicon glyphicon-user"></h4><br/>Profile
                                                        </a>
                                                        <li class="nav-item">
                            <a  class="nav-link" routerLink="/NewDashboard/PolicyWordings" routerLinkActive="activelink">{{'Policy Wordings'|translate}}</a>
                            <i class="fa fa-angle-right ioncssub"></i>
                        </li>
                                                        <a [routerLink]="['/NewReg']" class="list-group-item text-center">
                                                          <h4 class="glyphicon glyphicon-log-out"></h4><br/>Logout
                                                        </a>
                                                      </div>
                                                    </div>

                                                   
                                                    <div class="col-lg-11 col-md-11 col-sm-8 col-xs-12 bhoechie-tab">
                                                      <div class="LoadContent">
                                                          <router-outlet></router-outlet>
                                                      </div>
                                                              
                                                       
                                                    </div>
                                                </div>
                                          </div>
                                        </div>     
                                </div>

                                <div class="Clears"></div>
                </div>


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/Dashboard/Dashboard.html